import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-[75vh] flex items-center justify-center py-20 technical-grid">
      <SEO title="404 - Siden blev ikke fundet" />

      <div className="max-w-xl mx-auto px-4 text-center space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-cyan-950/70 border border-cyan-500/40 text-cyan-400 font-open-sans text-xs uppercase tracking-wider">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          <span>Fejl 404</span>
        </div>

        <h1 className="font-display text-4xl sm:text-6xl font-extrabold text-white tracking-tight">
          Siden blev ikke fundet
        </h1>

        <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
          Den ønskede side eksisterer desværre ikke eller er blevet flyttet. Benyt venligst nedenstående genveje for at finde det rette indhold.
        </p>

        <div className="pt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-5 py-3 rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
          >
            Forside
          </Link>
          <Link
            to="/konsulentydelser"
            className="px-5 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-700 text-xs font-open-sans transition-all"
          >
            Ydelser
          </Link>
          <Link
            to="/projekter"
            className="px-5 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-700 text-xs font-open-sans transition-all"
          >
            Projekter
          </Link>
          <Link
            to="/kontakt"
            className="px-5 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-cyan-400 border border-slate-700 text-xs font-open-sans transition-all"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
